import { responsiveContainer } from "@huub-web/ui/utils/responsive";
import { theme } from "@huub-web/ui/theme/css/theme.css";
import { globalStyle, style } from "@vanilla-extract/css";

const BREAKPOINT = 680;

export const pentaptychStyle = style({
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: theme.spacings.s,
  ...responsiveContainer({
    [BREAKPOINT]: {
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: theme.spacings.s,
    },
  }),
});

/**
 * The first panel (map or main image) spans the full width with a 4/3 ratio on
 * mobile, dropping the side cards below it. From the breakpoint up it returns
 * to the side column spanning two rows.
 */
globalStyle(".pentaptych > :nth-child(1)", {
  gridColumn: "1 / -1",
  gridRow: "span 1",
  aspectRatio: "4 / 3",
  ...responsiveContainer({
    [BREAKPOINT]: {
      gridColumn: "auto",
      gridRow: "span 2",
      aspectRatio: "auto",
    },
  }),
});
